import { Link } from "react-router-dom";
import { LOGOS_WHITE, BRAND_LIST, CONTACT_INFO } from "../data/brands";

export default function Footer({ brandKey = "group" }) {
  return (
    <footer className="bg-dejure-purple-dark text-white" data-testid="site-footer">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 py-16 md:py-24">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <img src={LOGOS_WHITE[brandKey]} alt="De Jure" className="h-14 w-auto" data-testid="footer-logo" />
            <p className="mt-6 max-w-sm font-sans text-sm leading-relaxed text-white/70">
              A house of professional excellence, Legal, Corporate, Marketing and
              Consulting Advisory, united under one trusted name in United Arab Emirates.
            </p>
          </div>

          <div>
            <p className="font-accent text-xs uppercase tracking-[0.2em] text-dejure-silver">
              The Group
            </p>
            <ul className="mt-5 space-y-3">
              <li>
                <Link to="/" data-testid="footer-link-group" className="font-sans text-sm text-white/80 hover:text-white transition-colors duration-300">
                  De Jure Group
                </Link>
              </li>
              {BRAND_LIST.map((b) => (
                <li key={b.key}>
                  <Link
                    to={b.to}
                    data-testid={`footer-link-${b.key}`}
                    className="font-sans text-sm text-white/80 hover:text-white transition-colors duration-300"
                  >
                    {b.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-accent text-xs uppercase tracking-[0.2em] text-dejure-silver">
              Contact
            </p>
            <ul className="mt-5 space-y-3 font-sans text-sm text-white/80">
              <li>United Arab Emirates</li>
              <li className="text-white/50">(Setting up a new location to host you)</li>
              <li>
                <a href={`mailto:${CONTACT_INFO.email}`} className="hover:text-white transition-colors duration-300">
                  {CONTACT_INFO.email}
                </a>
              </li>
              <li>
                <a href={`tel:${CONTACT_INFO.phone.replace(/\s/g, "")}`} className="hover:text-white transition-colors duration-300">
                  {CONTACT_INFO.phone}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-white/15 pt-8">
          <p className="font-sans text-xs text-white/50">
            © {new Date().getFullYear()} De Jure Group. All rights reserved.
          </p>
          <p className="font-accent text-[0.65rem] uppercase tracking-[0.3em] text-white/40">
            {brandKey === "legal" ? "United Arab Emirates" : "Dubai, United Arab Emirates"}
          </p>
        </div>
      </div>
    </footer>
  );
}
